import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Support double montage : dev (id="root") + WordPress (id="e2i-simulateur-root")
const rootElement =
  document.getElementById('e2i-simulateur-root') ||
  document.getElementById('root')

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
